import Link from '@commons/components/Link';

import type { CaseStudyNodeProps } from '.';

/**
 * CaseStudy node component for the Label display type.
 */

const CaseStudyNodeLabel = ({ title, alias }: CaseStudyNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default CaseStudyNodeLabel;
